import UniversalCookie from "universal-cookie";
import currentStorage from "./index";

const cookie = new UniversalCookie();

export const getUserRole = () => {
  return cookie.get("role");
};

export const clearStorage = () => {
  const storage = currentStorage();
  storage.clear();
};
